import { render, staticRenderFns } from "./PresentationMode.vue?vue&type=template&id=2b74965f&scoped=true&"
import script from "./PresentationMode.vue?vue&type=script&lang=ts&"
export * from "./PresentationMode.vue?vue&type=script&lang=ts&"
import style0 from "./PresentationMode.vue?vue&type=style&index=0&id=2b74965f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b74965f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
